import { put, select, takeLatest } from 'redux-saga/effects'

import { getBraintreeId, getUserId } from 'selectors'

import { braintree, common, error } from '../constants/actions'
import { braintree as btEndpoints } from '../constants/endpoints'
import { get, post } from '../utils/request'

export function* getBraintreePaymentMethods({ payload }) {
  const { type } = payload
  const customerId = yield select(getBraintreeId)

  if (!customerId) {
    yield put(braintree.setBTPaymentMethods([]))
    return
  }

  const params = {
    customerId,
    type,
  }

  const response = yield get({
    endpointId: btEndpoints.getPaymentMethods,
    params,
  })

  if (response.success) {
    yield put(braintree.setBTPaymentMethods(response.data))
  } else {
    yield put(
      error.onPaymentPageError({
        title: 'Error',
        description:
          'An error occurred while fetching saved PayPal accounts. Try again or select another payment method or continue with the new PayPal account.',
      })
    )
  }
}

export function* deleteBraintreePaymentMethod({ payload }) {
  yield put(common.setShowLoadingIndicator(true))
  const { token, type } = payload
  const response = yield post({
    endpointId: btEndpoints.deletePaymentMethod,
    data: {
      token,
      customerId: yield select(getBraintreeId),
      loggedInUser: yield select(getUserId),
    },
  })

  if (response.success) {
    yield put(braintree.getBTPaymentMethods({ type }))
  } else {
    yield put(
      error.onPaymentPageError({
        title: 'Error',
        description: 'An error occurred while deleting the saved PayPal account.',
      })
    )
    yield put(common.setShowLoadingIndicator(false))
  }
}

export function* runBraintreeSagas() {
  yield takeLatest(braintree.GET_BT_PAYMENT_METHODS, getBraintreePaymentMethods)
  yield takeLatest(braintree.DELETE_BT_PAYMENT_METHODS, deleteBraintreePaymentMethod)
}
